<template>
  <div class="">
    <div class="box-card">
      
      <div class="margin-top-40 box-card-bottom flex justify-between">
        <div class="bg-white radius-20 padding-left-30 box-card-bottom-left">
          <div class="text-000 about-content" v-if="aboutContent" v-html="aboutContent"></div>
          <div class="text-000 about-content placeholder" v-else>
            正在获取最新的关于我们内容...
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { fetchAbout } from "@/api/common";

export default {
  name: "About",
  data() {
    return {
      aboutContent: "",
    };
  },
  created() {
    this.getAboutContent();
  },
  methods: {
    getAboutContent() {
      fetchAbout()
        .then((res) => {
          this.aboutContent = res.data || "";
        });
    },
  },
};
</script>

<style scoped lang="scss">
.box-card {
  width: 90%;
  max-height: 452px;
  margin: 30px auto;

  &-img {
    width: 100%;
    max-height: 452px;
  }

  .about-content {
    padding-right: 30px;
    padding-bottom: 30px;
    line-height: 1.8;
    font-size: 14px;

    &.placeholder {
      color: #999;
    }

    :deep(*) {
      font-family: inherit !important;
      color: inherit !important;
    }

    :deep(img) {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 20px auto;
      border-radius: 8px;
    }

    :deep(p) {
      margin-bottom: 12px;
      word-break: break-word;
    }
  }
}
</style>
